import React from 'react';
import sampleVideo from "../../assets/sample-video.mp4"; 
import './home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="video-wrapper">
        <div className="video-container">
          <video
            autoPlay
            muted
            loop
            className="video-player"
          >
            <source src={sampleVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        {/* Blurred and darkened version of the video */}
        <div className="video-overlay">
          <video
            autoPlay
            muted
            loop
            className="video-overlay-player"
          >
            <source src={sampleVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default Home;
